import { Button, Typography, CircularProgress } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { getClientTheme } from "../../theme/clientTheme";
import { useData } from "../../context/DataContext";

const CustomButton = ({
  status = "idle",     // "idle" | "loading"
  onClick,
  label = "Submit",
  loadingLabel = "Submitting...",
  variant = "outlined",
  icon,
  color,
  btnColor,
  borderRadius,
  ...props
}) => {
  const { user_client_id} = useData();
  const clientTheme = getClientTheme(user_client_id);

  return (
    <div style={{ cursor: status === "loading" ? "not-allowed" : "pointer" }}>
      <Button
        variant={variant}
        disabled={status === "loading"}
        onClick={status === "loading" ? null : onClick}
        sx={{
          width: "100%",
          background: color ? color :  clientTheme.activeBg,
          color: "var(--light-bg)",
          border: "none",
          borderRadius: "8px",
          borderRadius: borderRadius ?? 'none',
          px: 2,
          py: 1,
          "&.Mui-disabled": {
            cursor: "not-allowed",          // ✅ force not-allowed cursor
            opacity: 0.7,                   // optional visual cue
            backgroundColor: clientTheme.activeBg, 
            color: "#FFF"      
          },
        }}
        {...props}
      >
        <Typography
          sx={{
            fontWeight: 500,
            color: "var(--white)",
            display: "flex",
            alignItems: "center",
          }}
        >
          {status === "loading" && (
            <CircularProgress
              size={15}
              sx={{ mr: 1, color: "var(--white)" }}  
            />
          )}
          {icon ? icon : <AddIcon color={btnColor} />}&nbsp;
          {status === "loading" ? loadingLabel : label}
        </Typography>
      </Button>
    </div>
  );
};

export default CustomButton;
